import { gsap } from 'gsap';

let scrollTriggerLoaded = false;
let splitTextLoaded = false;

export const loadScrollTrigger = async () => {
  if (scrollTriggerLoaded) return;

  const { default: ScrollTrigger } = await import('gsap/ScrollTrigger');

  gsap.registerPlugin(ScrollTrigger);
  scrollTriggerLoaded = true;
};

export const loadSplitText = async () => {
  if (splitTextLoaded) {
    const { default: SplitText } = await import('gsap/SplitText');

    return SplitText;
  }

  const { default: SplitText } = await import('gsap/SplitText');

  gsap.registerPlugin(SplitText);
  splitTextLoaded = true;

  return SplitText;
};
